import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditLabels } from '../../../actions/studio';
import { BatchEditLabel } from '../../../types/batchActions';
import { Props } from './LabelsBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditLabels'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  batchEditLabels: (labels: BatchEditLabel[]) =>
    dispatch(batchEditLabels(labels)),
});

export default connect(null, mapDispatchToProps);
